"use client";

import { getCurrentUser } from "aws-amplify/auth";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";
import { AuthenticatedProviders } from "@/app/providers/AuthenticatedProviders";
import { PublicProviders } from "@/app/providers/PublicProviders";
import { AppLayoutClient } from "@/components/AppLayout/components/AppLayoutClient/AppLayoutClient";

interface ErrorPageWrapperProps {
  children: ReactNode;
}

export function ErrorPageWrapper({ children }: ErrorPageWrapperProps) {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  // While checking auth, render without layout to avoid flash
  if (isAuthenticated === null) {
    return <div className="flex h-dvh w-full items-center justify-center bg-background">{children}</div>;
  }

  // Not authenticated - render full page without layout
  if (!isAuthenticated) {
    return <div className="flex h-dvh w-full items-center justify-center bg-background">{children}</div>;
  }

  // Authenticated - render with main layout and providers
  return (
    <PublicProviders>
      <AuthenticatedProviders>
        <AppLayoutClient>{children}</AppLayoutClient>
      </AuthenticatedProviders>
    </PublicProviders>
  );
}
